import React, { useState } from "react";
import LogoSprite from "./LogoSprite";

const FloatingWhatsAppButton = ({ phone, trackEvent, title }) => {
  const [loading, setLoading] = useState(false);
  const delay = 600;

  const submitTrackingForm = async (title, page) => {
    const formData = new FormData();
    formData.append("form-name", "whatsapp-track");
    formData.append("title", title);
    formData.append("page", page);

    try {
      await fetch("/", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/x-www-form-urlencoded",
        },
      });
    } catch (error) {
      console.error("Error enviando el formulario de tracking:", error);
    }
  };

  const handleClick = async () => {
    setLoading(true);

    const sanitizedPhone = phone.replace(/\s+/g, "");
    const pagePath = window.location.pathname;
    const cleanedTitle = title.replace(/\s*en Madrid/gi, "").trim();
    const message = `Hola, estoy visitando la web de Proyectop y quiero solicitar información sobre ${cleanedTitle}`;
    const waUrl = `https://wa.me/34${sanitizedPhone}?text=${encodeURIComponent(
      message
    )}`;

    // Matomo
    if (typeof trackEvent === "function") {
      trackEvent("WhatsApp", "Clic en botón", pagePath);
    }

    // Splitbee
    if (window.splitbee) {
      window.splitbee.track("WhatsApp", {
        type: "Clic",
        page: pagePath,
      });
    }

    // Netlify Forms (sin redirección)
    await submitTrackingForm(cleanedTitle, pagePath);

    // Redirige a WhatsApp en nueva pestaña
    setTimeout(() => {
      window.open(waUrl, "_blank", "noopener,noreferrer");
      setLoading(false);
    }, delay);
  };

  return (
    <>
      {/* Netlify needs a real <form> to register the form name */}
      <form
        name="whatsapp-track"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        hidden
      >
        <input type="hidden" name="form-name" value="whatsapp-track" />
        <input type="hidden" name="title" />
        <input type="hidden" name="page" />
      </form>

      <button
        onClick={handleClick}
        className="fixed group z-50 bottom-4 md:bottom-6 right-4 md:right-6 p-4 bg-green-500 rounded-full shadow"
        aria-label="Contáctanos por WhatsApp"
      >
        {loading ? (
          <svg
            aria-hidden="true"
            className="w-6 h-6 text-green-50 animate-spin fill-green-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        ) : (
          <LogoSprite id="whatsapp" className="size-6 fill-white" />
        )}
        <span className="absolute block normal-case font-semibold right-full whitespace-nowrap top-1/2 -translate-y-1/2 mr-1 px-3 py-2 rounded text-xs text-white bg-green-700 opacity-0 group-hover:opacity-100 transition-all duration-200 shadow text-center">
          M&aacute;ndanos un WhatsApp
          <span className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-full w-0 h-0 border-t-8 border-b-8 border-l-8 border-transparent border-l-green-700" />
        </span>
      </button>
    </>
  );
};

export default FloatingWhatsAppButton;
